import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, NoAuthGuard } from './guards';

import {     
    AssessmentComponent, 
    AssessmentsComponent, 
    ConfirmEmailComponent, 
    GoalsComponent, 
    LoginComponent,
    ReportsComponent,
    EmployeeComponent,
    EmployeeAddComponent,
    SettingsComponent,
    PasswordResetComponent,
    CompanySelectorComponent,
    SimpleSearchTestComponent,
    CancelUserDeleteComponent,
    PositionComponent,
    PrivacyPolicyComponent,
    GoalBasicSettingsComponent,
    CompanyPageComponent,
    TextBasedGoalComponent,
    NumericGoalComponent,
    GroupGoalComponent,
    TestPageComponent
} from './pages';

import {
    ReportComponent, 
    PersonalityTestDetailsComponent,
    PersonalityTestDiagramComponent,
    TeamDysfunctionsComponent,
    TeamStressMapComponent,
    PositionProfileReportComponent,
} from './reports';
import { ngxPermissionsGuard } from 'ngx-permissions';

// export function getPermissions(permissions: Permissions[]) {
//     console.log(permissions);
//     return ['Admin'];
// }

const routes: Routes = [
    {
        path: '', 
        component: AssessmentsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Értékelések készítése'
        }
    },
    {
        path: 'privacy-policy', 
        component: PrivacyPolicyComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Adatvédelmi irányelvek'
        }
    },    
    //{path: 'registration', component: RegistrationComponent},
    {
        path: 'login', 
        component: LoginComponent,
        canActivate: [NoAuthGuard],
        data: {
            title: 'Bejelentkezés'
        }
    },
    {
        path: 'password-reset/:userName',
        component: PasswordResetComponent,
        data: {
            title: 'Új jelszó beállítása'
        }
    },
    {
        path: 'cancel-user-delete',
        component: CancelUserDeleteComponent,
        data: {
            title: 'Felhasználó törlésének leállítása'
        }
    },
    // {
    //     path: 'users', 
    //     component: UsersComponent,
    //     canActivate: [AuthGuard, NgxPermissionsGuard],
    //     data: {
    //         title: 'Felhasználók',
    //         permissions: {
    //             only: [Permissions.SuperAdmin, Permissions.Admin, Permissions.Assistant]
    //         }
    //     }
    // },
    {
        path: 'confirmEmail/:userId', 
        component: ConfirmEmailComponent,
        data: {
            title: 'Email megerősítés'
        }
    },   
    {
        path: 'company-selector',
        component: CompanySelectorComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'simple-search-test',
        component: SimpleSearchTestComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'assessment/:reviewPeriodEmployeeId',
        component: AssessmentComponent,
        canActivate: [AuthGuard],
    },
        
    {
        path: 'reports/personality-test/diagram/:reviewPeriodEmployeeId',
        component: PersonalityTestDiagramComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'reports/personality-test/details/:reviewPeriodEmployeeId',
        component: PersonalityTestDetailsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'reports/team-dysfunctions/:reviewPeriodId',
        component: TeamDysfunctionsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'reports/team-stressmap/:reviewPeriodId',
        component: TeamStressMapComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'reports/panorama-aura/:employeeId/:reviewPeriodId',
        component: ReportComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'reports/position-profile-report', 
        component: PositionProfileReportComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Munkaköri profil riport'
        }
    },
    {
        path: 'reports', 
        component: ReportsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Riportok'
        }
    },
    {
        path: 'goals', 
        component: GoalsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Célkitűzés/nyomkövetés'
        }
    },
    {
        path: 'goal-basic-settings/:goalPeriodId', 
        component: GoalBasicSettingsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Célkitűzés alapadatok'
        }
    },
    {
        path: 'goals/:reviewPeriodId/:employeeId', 
        component: GoalsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'text-based-goal/:goalId',
        component: TextBasedGoalComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'add-text-based-goal/:goalPeriodId',
        component: TextBasedGoalComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'numeric-goal/:goalId',
        component: NumericGoalComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'group-goals/:goalPeriodId',
        component: GroupGoalComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'add-numeric-goal/:goalPeriodId',
        component: NumericGoalComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'employee', 
        component: EmployeeComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Dolgozó adatlap'
        }
    },
    {
        path: 'employee-add',
        component: EmployeeAddComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Dolgozó hozzáadás'
        }
    },
    {
        path: 'employee/:employeeId', 
        component: EmployeeComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Dolgozó adatlap'
        }
    },
    {
        path: 'position', 
        component: PositionComponent,
        canActivate: [AuthGuard, ngxPermissionsGuard],
        data: {
            title: 'Munkakörök',
            permissions: {
                only: ['SuperAdmin', 'Admin', 'Assistant']
            }
        }
    },
    {
        path: 'position/add', 
        component: PositionComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Munkakörök'
        }
    },
    {
        path: 'position/:positionId', 
        component: PositionComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Munkakörök'
        }
    }, 
    // {
    //     path: 'position',
    //     component: PositionComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         title: 'Munkakörök'
    //     }
    // },
    // {
    //     path: 'position/:positionId',
    //     component: PositionComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         title: 'Munkakör'
    //     }
    // },
    {
        path: 'company',
        component: CompanyPageComponent,
        canActivate: [AuthGuard, ngxPermissionsGuard],
        data: {
            title: 'Cégadatok',
            permissions: {
                only: ['SuperAdmin']
            }
        }
    },
    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Beállítások'
        }
    },
    {
        path: 'test-page',
        component: TestPageComponent,
        data: {
            title: 'Material Test Page'
        }
    },
    { 
        path: '**', 
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {}